import { render, staticRenderFns } from "./MediaCard.vue?vue&type=template&id=cbc49812&scoped=true"
import script from "./MediaCard.vue?vue&type=script&lang=js"
export * from "./MediaCard.vue?vue&type=script&lang=js"
import style0 from "./MediaCard.vue?vue&type=style&index=0&id=cbc49812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc49812",
  null
  
)

export default component.exports